import script from "./SaveSurveyTemplateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaveSurveyTemplateModal.vue?vue&type=script&setup=true&lang=ts"

import "./SaveSurveyTemplateModal.vue?vue&type=style&index=0&id=79c6b102&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c6b102"]])

export default __exports__